namespace JupitersChoice {
    export class SyncAnticipationCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('LocalStorageManager') _localStorageManager: Sapphire.LocalStorageManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('SpinModel') _spinModel: Sapphire.SpinModel;

        private _lsAnimations: any;
        private _ptAnimations: any;

        execute(): void {
            const response: any = this._server.logicResponse;
            const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ? response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            const lockedReels = this._responseHelper.getLockedReels(spinInfo.lockedWithPreviousReel);

            var shouldAnticipate: boolean;
            var glowingReels: boolean = false;
            var jupiterComponent;
            var anticipationRand = Math.floor(Math.random() * 10);
            var lightningStrikesOnReelsDoneOnce = false;

            // disable for now until clarified what we need to do
            shouldAnticipate = this._stateModel.currentSubgame === 'BaseGame' && (anticipationRand === 0 || lockedReels.length === 3);

            // for easier testing
            if (this._gameConfig.get('general', 'mode') === 'dev' && this._gameConfig.get('urlParams', 'alwaysAnticipate') === 'true' && this._stateModel.currentSubgame === 'BaseGame') {
                shouldAnticipate = true;
            }

            if (!shouldAnticipate && lockedReels.indexOf(4) >= 0) {
                glowingReels = true;
            }

            // animate current jupiter on screen
            if (this._stateModel.currentSubgame === 'FreeGame') {
                if (this._orientationModel.isLandscape) {
                    jupiterComponent = this._componentManager.get('JupiterFreeGameLandscape');
                } else {
                    jupiterComponent = this._componentManager.get('JupiterFreeGamePortrait');
                }

            } else {
                jupiterComponent = this._componentManager.get('JupiterBaseGame');
            }

            /*
            JUPITER CASTS FIRES LIGHTNING BOLT
            IN BASE GAME, TWO LIGHTNING BOLTS STRIKE THE REELS
            IN FREE GAME, WE JUST PLAY REEL LIGHTNING BACKER
            */

            this._lsAnimations = {
                throwAnim: 'throw1',
                throwCry: [1, 'battle_cry_05'],
                anticWin: 'throw1',
                anticLose: 'antic_lose2',
                winCry: [0.9, 'battle_cry_03']
            }

            this._ptAnimations = {
                throwAnim: 'portrait_antic2_win',
                anticWin: 'portrait_antic2_win',
                anticLose: 'antic_lose2',
                throwCry: [0, 'battle_cry_05'],
                winCry: [0, 'battle_cry_03']
            };

            if (this._stateModel.currentSubgame === 'FreeGame') {
                this._ptAnimations.anticWin = 'throw1';
                if (lockedReels.length >= 5) {
                    this._lsAnimations.throwAnim = 'throw2';
                    this._ptAnimations.throwAnim = 'throw2';

                    this._lsAnimations.throwCry = [0, 'battle_cry_05'];
                    this._ptAnimations.throwCry = [0, 'battle_cry_05'];
                } else {
                    this._lsAnimations.throwCry = null;
                    this._ptAnimations.throwCry = null;
                    this._ptAnimations.throwAnim = 'throw1';
                }
            }

            if (this.getAnimationForCurrentOrientation('throwCry')) {
                TweenMax.delayedCall(<number>this.getAnimationForCurrentOrientation('throwCry')[0], () => {
                    this._soundManager.play(<string>this.getAnimationForCurrentOrientation('throwCry')[1]);
                });
            }

            if (this._stateModel.currentSubgame === 'BaseGame' && this._orientationModel.isPortrait) {
                if (glowingReels) {
                    this._eventManager.publish('onDoBaseGameLightningGlowOnReels');
                } else {
                    if (!lightningStrikesOnReelsDoneOnce) {
                        this._eventManager.publish('onDoBaseGameLightningStrikesOnReels');
                        lightningStrikesOnReelsDoneOnce = true;
                    }
                }
            } else if (this._stateModel.currentSubgame === 'FreeGame') {
                TweenMax.delayedCall(0.5, () => {
                    this._eventManager.publish('onDoFreeGameFinalLightningStrikeOnReels');
                });

                if (lockedReels.length === 6) {
                    TweenMax.delayedCall(1.5, () => {
                        jupiterComponent.changeAnimation('laugh', false, false, () => {
                            jupiterComponent.changeAnimation('idle', false, true);
                        });
                        TweenMax.delayedCall(0.7, () => {
                            this._soundManager.play('vo_jupiter_fsmega_laugh');
                        });
                    });
                }
            }

            jupiterComponent.changeAnimation(this.getAnimationForCurrentOrientation('throwAnim'), true, false, (newOrientation) => {
                // the player may have changed orientation by the time jupiter completes his throw
                // if so, switch him to idle and wait for anticipation animation (if applicable)
                if (this._stateModel.currentSubgame === 'BaseGame') {
                    if (newOrientation === 'portrait') {
                        jupiterComponent.changeAnimation('idle', false, true);
                    }

                    if (glowingReels) {
                        this._eventManager.publish('onDoBaseGameLightningGlowOnReels');
                    } else {
                        if (!lightningStrikesOnReelsDoneOnce) {
                            this._eventManager.publish('onDoBaseGameLightningStrikesOnReels');
                            lightningStrikesOnReelsDoneOnce = true;
                        }
                    }

                    this._eventManager.publish('onUpdateReelLockStrips');
                }

                //this._componentManager.get('JupiterLightningBolt').tweenToPosition(250 * lockedReels[i], 600, 0.2)
                //this._componentManager.get('JupiterLightningBolt').play();

                if (shouldAnticipate) {
                    if (this._stateModel.currentSubgame === 'BaseGame') {
                        this._soundManager.play('reel_anticipation');

                        jupiterComponent.anticipationOnComplete = () => {
                            if (this._stateModel.currentSubgame === 'BaseGame') {
                                jupiterComponent.stopAnticipation();
                            }

                            if (lockedReels.length === 3) {
                                if (this.getAnimationForCurrentOrientation('winCry')) {
                                    TweenMax.delayedCall(<number>this.getAnimationForCurrentOrientation('winCry')[0], () => {
                                        this._soundManager.play(<string>this.getAnimationForCurrentOrientation('winCry')[1]);
                                    });
                                }
                                if (this._stateModel.currentSubgame === 'BaseGame' && this._orientationModel.isPortrait) {
                                    this._eventManager.publish('onDoBaseGameFinalLightningStrikeOnReels');
                                    this._soundManager.stop('reel_anticipation');
                                    this._soundManager.play('reel_anticipation_win');
                                }
                                jupiterComponent.changeAnimation(this.getAnimationForCurrentOrientation('anticWin'), true, false, () => {
                                    jupiterComponent.changeAnimation('idle', false, true);
                                    if (this._stateModel.currentSubgame === 'BaseGame' && this._orientationModel.isLandscape) {
                                        this._soundManager.stop('reel_anticipation');
                                        this._soundManager.play('reel_anticipation_win');
                                        this._eventManager.publish('onDoBaseGameFinalLightningStrikeOnReels');
                                    }
                                    this._eventManager.publish('onJupiterSequenceComplete');
                                });
                            } else {
                                TweenMax.delayedCall(0.5, () => {
                                    this._soundManager.stop('reel_anticipation');
                                    this._soundManager.play('reel_anticipation_lose');
                                });
                                jupiterComponent.changeAnimation(this.getAnimationForCurrentOrientation('anticLose'), true, false, () => {

                                    jupiterComponent.changeAnimation('idle', false, true);
                                    this._eventManager.publish('onJupiterSequenceComplete');
                                });
                            }
                        };

                        jupiterComponent.startAnticipation(this._orientationModel.getCurrentOrientation());
                    } else {
                        jupiterComponent.changeAnimation('portrait_antic2_intro', false, false, () => {
                            jupiterComponent.changeAnimation('portrait_antic2_idle', false, true);
                        });
                    }
                } else {
                    jupiterComponent.changeAnimation('idle', false, true);
                    this._eventManager.publish('onJupiterSequenceComplete');
                }
            });

            if (this._stateModel.currentSubgame === 'FreeGame') {
                TweenMax.delayedCall(1, () => {
                    jupiterComponent.changeAnimation('idle', false, true);
                    this._eventManager.publish('onJupiterSequenceComplete');
                });
            }
        }

        getAnimationForCurrentOrientation(animationKey: string): void {
            let currentOrientation = this._orientationModel.getCurrentOrientation();

            if (currentOrientation === 'landscape') {
                return this._lsAnimations[animationKey];
            } else {
                return this._ptAnimations[animationKey];
            }
        }
    }
}
